import React, { useState } from 'react';
import { postAdminMerchantSignupInvite } from '../services/adminApi';
import { extractErrorMessage } from '../../../shared/utils/errorHandling';

export default function LoyalPassAdminInviteMerchantPage() {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        setSuccess(null);
        try {
            const res = await postAdminMerchantSignupInvite({ email: email.trim() });
            setSuccess(res.data?.email || email.trim());
            setEmail('');
        } catch (err) {
            setError(extractErrorMessage(err) || 'Failed to send invite');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="p-6 max-w-lg mx-auto">
            <h1 className="text-2xl font-semibold text-slate-900">Invite a merchant</h1>
            <p className="text-slate-600 mt-2 text-sm">
                Send an email with a link to your public merchant registration page. They create their business
                account the same way as any new signup from your marketing site.
            </p>

            <form onSubmit={submit} className="mt-6 space-y-4 rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
                <div>
                    <label htmlFor="invite-email" className="block text-sm font-medium text-slate-700 mb-1">
                        Email address
                    </label>
                    <input
                        id="invite-email"
                        type="email"
                        required
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="prospect@example.com"
                        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                    />
                </div>
                {error && (
                    <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
                        {error}
                    </div>
                )}
                {success && (
                    <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-900">
                        Invite sent to <span className="font-medium">{success}</span>.
                    </div>
                )}
                <button
                    type="submit"
                    disabled={busy || !email.trim()}
                    className="w-full rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 disabled:opacity-50"
                >
                    {busy ? 'Sending…' : 'Send invite email'}
                </button>
            </form>

            <p className="mt-4 text-xs text-slate-500">
                Requires Resend (RESEND_API_KEY) and MAIL_FROM on the server. Invites are blocked for addresses
                already linked to a merchant or reserved for platform admin.
            </p>
        </div>
    );
}
